import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EventManager, AlertService} from 'ng-jhipster';
import {Saisine, SaisineStatus} from './saisine.model';
import {SaisineService} from './saisine.service';
import {Rejection} from '../rejection/rejection.model';
import {UtilsService} from '../../shared/utils/utils.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'jhi-saisine-canceled',
    templateUrl: './saisine-canceled.component.html'
})
export class SaisineCanceledComponent implements OnInit {
    @Input() saisine: Saisine;

    @Output() saisineChange = new EventEmitter();

    saisineStatus = SaisineStatus;

    rejection: Rejection;

    isSaving: boolean;

    constructor(
        private saisineService: SaisineService,
        private eventManager: EventManager,
        private alertService: AlertService,
        public utilsService: UtilsService,
        private modalService: NgbModal) {}

    ngOnInit() {
        this.rejection = new Rejection;
    }

    rejectSaisine(content, saisineId: number) {
        this.modalService.open(content).result.then((result) => {
            this.isSaving = true;
            this.saisineService.cancelSaisine(saisineId, this.rejection).subscribe(
                this.onSaveSuccess,
                this.onSaveError
            );
        }, (reason) => {
        });
    }

    // this binding
    onSaveSuccess = () => {
        this.isSaving = false;
        this.saisineChange.emit();
    }

    // this binding
    onSaveError = (error) => {
        this.isSaving = false;
        this.onError(error);
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/saisine/saisine-canceled.component.ts